export default class SensorsAPIClient {
    apiUrl = "https://sensors-api.codert.pl";
    data = {
        measurements: [],
        sensors: []
    };

    /**
     * Fetch measurements data from the API
     * @param force set tru to force requests API
     * @returns {Promise<null>}
     */
    async getMeasurements(sensor){
        this.data.measurements = await fetch(this.apiUrl + '/measurements' + '?filter[sensor]=' + sensor)
            .then(resp => {
                return resp.json();
            });
        return this.data.measurements;
    }

    async getSensors(){
        this.data.sensors = await fetch(this.apiUrl + '/sensors')
            .then(resp => {
                return resp.json();
            });
        return this.data.sensors;
    }

}